import styled from 'styled-components';
import { textSize, brand, ink, surface, tones } from '../../styles/brand';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`;

export const Group = styled.fieldset`
  border: 0;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  min-width: 0;
`;

export const GroupTitle = styled.legend`
  padding: 0;
  margin-bottom: 0.45rem;
  font-family: 'RedHatDisplay-Bold';
  font-size: ${textSize(0.85)};
  letter-spacing: 0.01em;
  color: ${ink};
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.8)};
  color: ${tones.gray.text};
`;

export const Sentence = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.9)};
  color: ${ink};
`;

export const NumberBox = styled.input<{ $hasError?: boolean; $width?: string }>`
  width: ${({ $width }) => $width ?? '4.2rem'};
  height: 2.6rem;
  border: 1px solid
    ${({ $hasError }) => ($hasError ? tones.red.border : surface.line)};
  border-radius: 0.55rem;
  padding: 0 0.6rem;
  font-family: 'RedHatDisplay-Bold';
  font-size: ${textSize(1)};
  font-variant-numeric: tabular-nums;
  text-align: center;
  color: ${ink};
  background: #fff;
  outline: none;
  transition:
    border-color 120ms ease-out,
    box-shadow 120ms ease-out;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    border-color: ${({ $hasError }) =>
      $hasError ? tones.red.border : brand.orange};
    box-shadow: 0 0 0 3px
      ${({ $hasError }) =>
        $hasError ? 'rgba(255, 46, 62, 0.15)' : 'rgba(255, 152, 0, 0.18)'};
  }

  &:disabled {
    background: #f6f6f6;
    color: #999;
  }
`;

export const MinSec = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-family: 'RedHatDisplay-Bold';
  color: ${tones.gray.text};
`;

export const Unit = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.85)};
  color: ${tones.gray.text};
`;

export const ErrorText = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.78)};
  color: #d92332;
`;

export const Footer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem 1rem;
`;

export const Hint = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.78)};
  color: ${tones.gray.text};
`;

export const ResetButton = styled.button`
  border: 0;
  background: none;
  padding: 0.2rem 0;
  font-family: 'RedHatDisplay-Bold';
  font-size: ${textSize(0.78)};
  color: #e08600;
  cursor: pointer;

  &:active {
    opacity: 0.6;
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;
